const clone = (value) => {
  if (!value || typeof value !== 'object') return value;
  try { return structuredClone(value); } catch { return JSON.parse(JSON.stringify(value)); }
};

export function sanitizeRuntimeConfig(payload = {}) {
  if (!payload || typeof payload !== 'object') return payload;

  const sanitized = clone(payload);
  if (sanitized.serviceProfile === 'aws_standard') {
    const pick = (input, keys) => Object.fromEntries(keys
      .filter(key => ['string', 'boolean'].includes(typeof input?.[key]))
      .map(key => [key, input[key]]));
    return {
      serviceProfile: 'aws_standard',
      controlPlane: pick(sanitized.controlPlane, ['base', 'aiTurnBase']),
      app: pick(sanitized.app, ['name', 'version', 'env', 'sha', 'url']),
      tenantAdmin: pick(sanitized.tenantAdmin, ['url']),
      operatorContact: typeof sanitized.operatorContact === 'string' ? sanitized.operatorContact : '',
      auth: { cognito: pick(sanitized.auth?.cognito, [
        'enabled', 'region', 'userPoolId', 'clientId', 'domain', 'redirectUri', 'logoutUri'
      ]) }
    };
  }
  for (const sectionName of ['lightrag', 'LIGHTRAG']) {
    const section = sanitized?.[sectionName];
    if (!section || typeof section !== 'object') continue;
    for (const key of Object.keys(section)) {
      if (key.replace(/[^a-z0-9]/gi, '').toLowerCase() === 'apikey') {
        delete section[key];
      }
    }
  }
  return sanitized;
}

export default sanitizeRuntimeConfig;
